import { Autoplay } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';

import { useState } from 'react';
import { useSelector } from 'react-redux';

import SwiperFooter from 'components/global/SwiperFooter';

import useAccessControl from 'hooks/useAccessControl';

import PATHS from 'utils/paths';

import AnnouncementSlideContent from '../AnnouncementSlideContent';
import * as S from './Onboarding.styled';

const OnboardingAnnouncements = () => {
	const {
		localization: { dir }
	} = useSelector((state) => state.layout);
	const isAuthorized = useAccessControl();

	const [swiperRef, setSwiperRef] = useState(null);

	const announcementSlidesConfig = [
		...(isAuthorized('/price-calculator')
			? [
					{
						header: 'compareShippingPrices',
						content: 'compareShippingPricesDescription',
						actionLabel: 'findBestRates',
						actionType: 'navigate',
						actionUrl: PATHS.PRICE_CALCULATOR,
						desktopBGImage: JSON.stringify({
							arabicValue:
								'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/desktop/comparePricesAr.svg',
							engValue:
								'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/desktop/comparePricesEn.svg',
							trValue:
								'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/desktop/comparePricesTr.svg'
						}),
						mobileBGImage: JSON.stringify({
							arabicValue:
								'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/mobile/comparePricesAr.svg',
							engValue:
								'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/mobile/comparePricesEn.svg',
							trValue:
								'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/mobile/comparePricesTr.svg'
						})
					}
				]
			: []),
		{
			header: 'compareOtoPlans',
			content: 'compareOtoPlansDescription',
			actionLabel: 'chooseYourPlan',
			actionType: 'navigate',
			actionUrl: PATHS.OTO_MODULES,
			desktopBGImage: JSON.stringify({
				arabicValue:
					'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/desktop/comparePlansAr.svg',
				engValue:
					'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/desktop/comparePlansEn.svg',
				trValue:
					'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/desktop/comparePlansTr.svg'
			}),
			mobileBGImage: JSON.stringify({
				arabicValue:
					'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/mobile/comparePlansAr.svg',
				engValue:
					'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/mobile/comparePlansEn.svg',
				trValue:
					'https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/onboardingBanners/newBanners/mobile/comparePlansTr.svg'
			})
		}
	];

	return (
		<S.Announcements padding={0}>
			<S.SwiperWrapper
				key={`onboarding-announcements-${dir}`}
				dir={dir}
				modules={[Autoplay]}
				autoplay={{
					delay: 3000,
					disableOnInteraction: false
				}}
				onSwiper={setSwiperRef}>
				{announcementSlidesConfig.map((slide, index) => (
					<SwiperSlide key={index} style={{ overflow: 'hidden' }}>
						<AnnouncementSlideContent slide={slide} />
					</SwiperSlide>
				))}
				{swiperRef && <SwiperFooter swiperRef={swiperRef} />}
			</S.SwiperWrapper>
		</S.Announcements>
	);
};

export default OnboardingAnnouncements;
